export const CREATE_EXPENSE_TRANSACTION = 'CREATE_EXPENSE_TRANSACTION';
export const EDIT_EXPENSE_TRANSACTION = 'EDIT_EXPENSE_TRANSACTION';
export const SHOW_EXPENSE_TRANSACTION = 'SHOW_EXPENSE_TRANSACTION';
export const EXPENSE_TRANSACTION_SUCCESS = 'EXPENSE_TRANSACTION_SUCCESS';
export const EXPENSE_TRANSACTION_ERROR = 'EXPENSE_TRANSACTION_ERROR';

